import { NgModule } from '@angular/core';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DdMmYyyyDateAdapter, DD_MM_YYYY_FORMATS } from './dd-mm-yyyy-date-adapter';

/**
 * Drop-in replacement for MatNativeDateModule that makes every Material datepicker
 * display/parse dates as dd-MM-yyyy. Import this wherever MatNativeDateModule was used.
 */
@NgModule({
  imports: [MatNativeDateModule],
  exports: [MatNativeDateModule],
  providers: [
    { provide: DateAdapter, useClass: DdMmYyyyDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMATS }
  ]
})
export class DdMmYyyyDateModule {}
